module.exports = __webpack_public_path__ + "img/erwema2.c451f0da.png";